import  {useState } from 'react';
import { Link,useLocation} from 'react-router-dom';
import FilterPage from '../component/FilterPage';
//import myLogoOnly from '../assets/img/logo-only.png';
import { ChevronRight, ChevronLeft,ChartBarStacked } from 'lucide-react';
  
 
export default function Sidebar( { isOpen, onClose,onCollapsedChange }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleCollapseToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    onCollapsedChange?.(newState);
  };

     
return (
<>
{isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}
      <aside className={`w-64 bg-slate-200 text-black h-screen fixed left-0 top-0 overflow-y-auto transition-transform duration-300 z-30 ${
        isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      } ${isCollapsed ? 'w-20 lg:w-20' : 'w-64 lg:w-64'}`}>
        <div className="p-1 m-2">
        <div className={` mb-8 }`}>
         
          FRONTEND ASSIGNMENT 
          
        </div>
          
        <nav className="space-y-1">
          <FilterPage></FilterPage>
          
        </nav>
      </div>
    </aside>
  
</>


)
}